// var configEnv = "development";
// var configEnv = "staging";
// var configEnv = "production";
var configEnv = "v1";

var config = {
  //######### Staging config ##########

  v1: {
    appUrl: "https://v1.falgun-garmenting.com",
    apiUrl: "https://v1api.falgun-garmenting.com/api",
    staticUrl: "https://v1api.falgun-garmenting.com/api",
    debug: true,
  },

  staging: {
    appUrl: "https://v1.falgun-garmenting.com",
    apiUrl: "https://erpapi.falgun-garmenting.com/api",
    staticUrl: "https://erpapi.falgun-garmenting.com/api",
    debug: true,
  },
  production: {
    appUrl: "https://erp.falgun.org",
    apiUrl: "https://erpapi.falgun.org/public/api",
    staticUrl: "https://erpapi.falgun.org/public/api",
    debug: true,
  },
  //########## Local config ##########
  development: {
    appUrl: "http://localhost:3000",
    apiUrl: "http://localhost/erp-back-running/public/api",
    staticUrl: "http://localhost/erp-back-running/public/api",
    debug: true,
  },
};

var finalConfig = config[configEnv];
export default finalConfig;
